import { useState } from "react";

export const RetroWindow = ({ id, title, icon, testid, className = "", children, statusbar }) => {
  const [min, setMin] = useState(false);
  return (
    <section id={id} data-testid={testid} className={`w98-window ${className}`}>
      <div className="w98-title">
        <span className="flex items-center gap-1.5 truncate">{icon}{title}</span>
        <span className="flex gap-0.5 shrink-0">
          <button type="button" className="w98-tbtn" onClick={() => setMin(!min)} aria-label="minimize"
            data-testid={`${testid}-minimize`}>{min ? "▫" : "_"}</button>
          <span className="w98-tbtn" aria-hidden="true">□</span>
          <span className="w98-tbtn ml-0.5" aria-hidden="true">×</span>
        </span>
      </div>
      {!min && <div className="p-3 sm:p-4">{children}</div>}
      {!min && statusbar && <div className="w98-statusbar">{statusbar}</div>}
    </section>
  );
};
